import React, { memo } from 'react';
import styled from 'styled-components';
import Thumb from './thumb';

export const ThumbGallery = ({ images, setSelectedImageIndex, handleClick, selectedImage, alt }) => {
  if (images.length <= 1) {
    return null;
  }

  return (
    <Container>
      {images.map((image, index) => (
        <Thumb
          key={image.imageListSize.thumbnail}
          index={index}
          src={image.imageListSize.thumbnail}
          isVideo={image.video}
          setSelectedImage={setSelectedImageIndex}
          selected={image.isSelected}
          remainingQuantity={image.remainingQuantity}
          handleClick={handleClick}
          alt={`${alt} - Imagem ${index + 1}`}
        />
      ))}
    </Container>
  );
};

const Container = styled.div`
  height: 100px;
  display: flex;
  align-items: center;
`;

export default memo(ThumbGallery);
